import { Injectable } from '@angular/core';
import { ERoutesApi } from '@core/enums';
import { GenericCrudService } from '@core/services';
import { _Apr } from '../model';

@Injectable({ providedIn: 'root' })
export class AprService extends GenericCrudService<_Apr, _Apr> {
  constructor() {
    super(ERoutesApi.APR);
  }

  toFormData(dto: any, removeuArquivo: boolean) {
    const formData = new FormData();

    Object.entries(dto).forEach((attribute) => {
      if ((attribute[0] === 'anexo' && attribute[1] !== '') || attribute[0] !== 'anexo' || removeuArquivo) {
        // todo possivel melhoria de tipagem
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        formData.append(attribute[0], attribute[1]);
      }
    });

    return formData;
  }

  importarApr(formDataDto: FormData) {
    return this.httpService.postWithFile(`${ERoutesApi.APR}/importar`, formDataDto);
  }
  countAprs () {
    return this.httpService.get(`${ERoutesApi.APR}/count-all`)
  }

  handleHistory(id: number, limit: number, offset: number) {
    return this.httpService.get(`${ERoutesApi.APR}/history/${id}/${offset}/${limit}`).pipe().toPromise();
  }
}
